/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_ButtonInputs */

const zh_landing_cta_button = /** @type {(inputs: Landing_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const en_landing_cta_button = /** @type {(inputs: Landing_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start for free`)
};

const es_landing_cta_button = /** @type {(inputs: Landing_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza gratis`)
};

/**
* | output |
* | --- |
* | "Start for free" |
*
* @param {Landing_Cta_ButtonInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_cta_button = /** @type {((inputs?: Landing_Cta_ButtonInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_ButtonInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_cta_button(inputs)
	if (locale === "en") return en_landing_cta_button(inputs)
	return es_landing_cta_button(inputs)
});